import { createContext } from 'react'

const ContentHeaderContext = createContext()

export default ContentHeaderContext
